export default function detectIosVersion() {
    var _a;
    if (typeof window === "undefined" || ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) == null) {
        return 0;
    }
    const ua = window.navigator.userAgent;
    if (/iPad|iPhone|iPod/.test(ua)) {
        const matches = / OS (\d\d)_/.exec(ua);
        if (matches != null && matches.length > 1) {
            return parseInt(matches[1]);
        }
        return 10;
    }
    if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
        const matches = /Version\/(\d\d)/.exec(ua);
        if (matches != null && matches.length > 1) {
            return parseInt(matches[1]);
        }
        return 13;
    }
    return 0;
}
